var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilSimpleLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.238 9.348L22.65 3.762a1.75 1.75 0 00-2.475 0L4.763 19.177a1.742 1.742 0 00-.513 1.237V26A1.75 1.75 0 006 27.75h5.586a1.742 1.742 0 001.238-.512l15.414-15.415a1.75 1.75 0 000-2.475zM11.762 26.177a.25.25 0 01-.176.073H6a.25.25 0 01-.25-.25v-5.586a.25.25 0 01.074-.176L17 9.06 22.939 15 11.762 26.177zm15.414-15.414L24 13.939 18.061 8l3.177-3.177a.25.25 0 01.353 0l5.585 5.586a.251.251 0 010 .354z"
  })));
}
export default SvgPencilSimpleLight;